import { CursorQuery, Paginated } from '../../common/pagination.js';
import { DeletedNotification, NotificationView, UnreadCount } from '../../notifications.js';
export const notificationsRoutes = {
    list: {
        method: 'GET',
        path: '/notifications',
        query: CursorQuery,
        response: Paginated(NotificationView),
    },
    unreadCount: {
        method: 'GET',
        path: '/notifications/unread-count',
        response: UnreadCount,
    },
    markSeen: {
        method: 'POST',
        path: '/notifications/seen',
        response: UnreadCount,
    },
    remove: {
        method: 'DELETE',
        path: '/notifications/:notificationId',
        response: DeletedNotification,
    },
};
//# sourceMappingURL=routes.js.map